// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__VStcB","rightMenu":"Menu_rightMenu__O36og","clientLogo":"Menu_clientLogo__f+Iuo","clientLogoWrapper":"Menu_clientLogoWrapper__BIcgD"};